import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AboutSection() {
  const { ref, isVisible } = useScrollReveal(0.15);

  return (
    <section id="about" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[960px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/60 px-3 py-1 rounded-full mb-3">
            品牌故事
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            了解黑料718从零到一的初心与愿景
          </p>
        </div>

        <div className={`bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-12 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <div className="max-w-[720px] mx-auto">
            <div className="flex items-center justify-center mb-8">
              <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center">
                <span className="text-2xl font-heading font-bold text-background-50">718</span>
              </div>
            </div>
            <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-5">
              <p>
                黑料718成立于2025年，是一个专注于<strong className="text-foreground-900">正能量黑料内容精选与传播</strong>的独立内容平台。在信息爆炸的时代，我们观察到传统八卦和爆料内容多以负面信息为主，充斥焦虑与戾气。于是我们决定做一件不一样的事——
              </p>
              <p>
                我们每天从海量信息中甄选那些<strong className="text-foreground-900">积极向上、温暖人心、富有正能量的黑料故事</strong>。无论是明星私下的暖心善举、普通人身上的不凡力量，还是社会各界的正能量事件，只要是真实、有温度、能给人带来力量的"黑料"，都是我们的选材范围。
              </p>
              <p>
                在这里，<strong className="text-foreground-900">"黑料"不再是阴暗的标签，而是发光发热的正能量载体</strong>。我们希望通过内容的筛选与传播，让更多人看到这个世界的善意与温暖，让每一次浏览都成为一次心灵的充电。
              </p>
              <p>
                目前黑料718已覆盖<strong className="text-foreground-900">明星正能量、社会暖心、职场励志、科技趣闻、体育精神、校园正能量、公益行动、家庭温情</strong>等八大核心话题领域，日均精选更新超过50条优质内容，持续为数百万正能量读者提供温暖而有力量的内容体验。
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 pt-8 border-t border-background-200/50">
              {[
                { num: '500+', label: '累计原创内容' },
                { num: '100万+', label: '月活跃读者' },
                { num: '99.7%', label: '内容真实率' },
                { num: '8', label: '核心内容板块' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <p className="text-xl md:text-2xl font-heading font-bold text-primary-600">{stat.num}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}